<template>
  <div>
    <div id="main-menu" class="container">
      <tabs>
        <tab name="Services" :selected="true"></tab>
      </tabs>
    </div>
    <button @click="logout" class="btn btn-link">
      Salir
    </button>
    <div class="card">
      <div class="card-header">Demo Form</div>
      <formio ref="testFormFef" :src="demoformio" @submitDone="onSubmitDone" :options="{saveDraft: true}" ></formio>
    </div>
    <router-link class="btn btn-primary" :to="{ name: 'allSubmissions' }">Todos mis submissions</router-link>
  </div>
</template>

<script>

import { FORMIO_ENDPOINT } from '@/api/formioApi'
import { mapActions } from 'vuex'
import { Form } from "vue-formio";
import { tabs, tab } from "@component-basic/tabs"

export default {
  components: {
    formio: Form,
    tabs: tabs,
    tab, tab
  },
  mounted(){
    console.log(this.$refs.testFormFef.$options)
  },
  computed: {
    demoformio() {
      return `${FORMIO_ENDPOINT}/demoform`
    }
  },
  methods: {
    onSubmitDone(submission) {
      console.log(submission)
      this.$router.push({ name: 'allSubmissions' })
    },
    ...mapActions('user', [
      'logout'
      ])
  }
}
</script>
